import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditRegion = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [regionData, setRegionData] = useState({});
  const [OpenAlert, setOpenAlert] = useState(false);
  const [countries, setCountries] = useState([]);
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [RegionValue, setRegionValue] = useState('');
  const [countryValue, setCountryValue] = useState<any>({});
  const [spinner, setSpinner] = useState(false);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...regionData };
    item[name] = value;
    if (name === 'country') {
      setCountryValue(JSON.parse(value));
    } else {
      setRegionData(item);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (regionData['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        regionData['name'] = props.region['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        regionData['country'] = countryValue;
        const response = httpClient.current?.put(`/api/region/update`, regionData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.regions();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      console.log(error);
      setSpinner(false);
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    regionData['name'] = props.region.name;
    setCountryValue(props.region.country);
    setUpdateModal(!UpdateModal);
  };

  useEffect(() => {
    setRegionData(props.region);
    console.log(props.region);
  }, [props.region]);
  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient]);

  return (
    <>
      <EditButtonIcon
        title={props.t('update_region')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_region')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    value={regionData['name']}
                    onChange={(event) => setRegionValue(event.target.value)}
                    placeholder={props.t('placeholder_region_name')}
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <select
                    className="form-control"
                    name="country"
                    id="country"
                    defaultValue={JSON.stringify(regionData['country'])}
                    onChange={(event) => setRegionValue(event.target.value)}
                  >
                    <option value="">{props.t('select_country')}</option>
                    {countries.map((country) => (
                      <option key={country.id} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={UpdateModalToggle}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditRegion);
